
// NOTE: Search and find any <a> element with #contact.
//       These elements need to trigger contact pop up.

export const contactSetup = () => {
  // Contact Form Setup
  // NOTE: Adding an arrow icon to button: _contact.scss
  // Commented for now due to image link being broken.
  // if (document.querySelector('.fui-submit')) {
  //   let arrowImg = document.createElement('img');
  //   arrowImg.src = '/assets/global/arrow_orange.svg';
  //   document.querySelector('.fui-submit').appendChild(arrowImg);
  // }


  document.querySelectorAll('a').forEach(element => {
    if (element.href.includes('#contact')) {
      element.classList.add('nav-contact-toggle');
      element.removeAttribute('href');
    }
  });

  // If the url has /#contact parameter, it toggles open contact menu
  if (window.location.hash === '#contact') {
    document.querySelector('#contact-menu').classList.toggle('nav-toggle');
    document.querySelector('#nav-toggle-backdrop').classList.toggle('nav-toggle');
  }
};

export const contactReady = () => {
  // Intialize Slide Menu
  document.querySelectorAll('.nav-contact-toggle').forEach(element => {
    element.addEventListener('click', contactSlideOn);
  });
  
  // Close Menu
  document.querySelectorAll('.contact-menu-close').forEach(element => {
    element.addEventListener('click', contactSlideOff);
  });
};

const contactSlideOn = () => {
  if (!document.querySelector('#nav-menu').classList.contains('nav-toggle')) {
    document.querySelector('#nav-menu').classList.add('nav-toggle');
  };
  document.querySelector('#contact-menu').classList.toggle('nav-toggle');
  document.querySelector('#nav-toggle-backdrop').classList.remove('nav-toggle');
};

const contactSlideOff = () => {
  document.querySelector('#contact-menu').classList.toggle('nav-toggle');
  document.querySelector('#nav-toggle-backdrop').classList.toggle('nav-toggle');
};
